import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function useENO1Finalize() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileId: number) => {
      const response = await axios.get(`/data-set/eno1/finalize`, {
        params: {
          dataSet: fileId
        }
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate relevant queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['eno1Samples'] });
      queryClient.invalidateQueries({ queryKey: ['eno1FileDetails'] });
    }
  });
} 